import LoadingComponent from './LoadingComponent.vue'

/**
 * 包装异步组件加载状态
 * @param {Promise} lazyComponent  异步组件，如 () => import('xxx.vue')
 * @returns {Promise} 返回异步组件
 */
const asyncComponent = (lazyComponent) => () => ({
  component: lazyComponent(),
  loading: LoadingComponent
})

export default asyncComponent
